module.exports = __webpack_public_path__ + "static/media/pancakeswap.e50571b9.svg";